import React, { useContext } from 'react';
import moment from 'moment';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { toast } from 'react-toastify';

import {
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  List,
  ListItem,
  IconButton,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Switch,
  Stack,
  Button,
} from '@mui/material';
import Swal from 'sweetalert2';
import DeleteIcon from '@mui/icons-material/Delete';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EventIcon from '@mui/icons-material/Event';
import ArticleIcon from '@mui/icons-material/Article';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import AddIcon from '@mui/icons-material/Add';
import CelebrationIcon from '@mui/icons-material/Celebration';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import CircularProgress from '@mui/material/CircularProgress';
import useStore from '../../../states/store';
// Components
import AppointmentCalendar from '../../../components/AppontmentCalendar';
import useEventCalendarContext from '../context/useEventCalendarContext';
import { postCalendarDelete, postCalendarPlottable } from '../../../api/eventCalendarApi';

export default function EventCalendarTab() {
  const {
    calendarData,
    calendarList,
    addEventModal,
    setAddEventModal,
    eventTypeOptions,
    handleGenerateFilter,
    handleGenerateListFilter,
    selectedCalendarForm,
    setSelectedCalendarForm,
    selectedDate,
    setSelectedDate,
    setCalendarList,
    handleViewEvent,
  } = useContext(useEventCalendarContext);
  const auth = useStore((state) => state.auth);

  const renderEventTypeIcon = (name) => {
    if (name === 'Regular Holiday') {
      return (
        <Avatar sx={{ backgroundColor: '#004080' }}>
          <NewReleasesIcon />
        </Avatar>
      );
    }

    if (name === 'Special Holiday') {
      return (
        <Avatar sx={{ backgroundColor: '#349B96' }}>
          <CelebrationIcon />
        </Avatar>
      );
    }

    if (name === 'Company Related') {
      return (
        <Avatar sx={{ backgroundColor: '#D4AF37' }}>
          <EventIcon />
        </Avatar>
      );
    }

    return (
      <Avatar sx={{ backgroundColor: '#7DBE62' }}>
        <ArticleIcon />
      </Avatar>
    );
  };

  const handleClickDate = (data) => {
    setSelectedDate(data.date);

    const newCalendarParams = {
      ...selectedCalendarForm,
      date: data.date,
      hasSelected: true,
    };

    setSelectedCalendarForm(newCalendarParams);

    handleGenerateListFilter(newCalendarParams);
  };

  const handleResetSelected = () => {
    const newCalendarParams = {
      ...selectedCalendarForm,
      date: null,
      hasSelected: false,
    };

    setSelectedCalendarForm(newCalendarParams);
    setSelectedDate('');
    handleGenerateListFilter();
  };

  const handleDeleteEvent = async (id) => {
    try {
      Swal.fire({
        icon: 'warning',
        title: `Are you sure you want to delete event?`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<small style="color:#fff"> Confirm </small>',
        cancelButtonText: '<small style="color:#fff"> Cancel </small>',
      }).then((response) => {
        if (response.isConfirmed) {
          toast.loading('Processing request please kindly wait...');
          const request = {
            datas: [id],
          };
          postCalendarDelete(request).then((res) => {
            const { code, message } = res.data.response;
            if (code === '00005') {
              toast.success(message);
              handleGenerateFilter();
            }
            toast.dismiss();
          });
        }
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handlePlottableEvent = async (event, row, i, x) => {
    try {
      const isChecked = event.target.checked ? 1 : 0;
      Swal.fire({
        icon: 'warning',
        title: `Are you sure you want to make this ${
          isChecked === 1 ? 'plottable' : 'unplottable'
        }?`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<small style="color:#fff"> Confirm </small>',
        cancelButtonText: '<small style="color:#fff"> Cancel </small>',
      }).then((response) => {
        if (response.isConfirmed) {
          toast.loading('Processing request please kindly wait...');
          const request = {
            datas: [
              {
                id: row?.id,
                is_plottable: isChecked,
              },
            ],
          };
          postCalendarPlottable(request).then((res) => {
            const { code, message } = res.data.response;
            if (code === '200') {
              toast.dismiss();
              toast.success(message);
              const listArr = [...calendarList.list];

              listArr[i].details[x] = {
                id: row?.id,
                date: row?.date,
                is_enabled: row?.is_enabled,
                is_plottable: isChecked,
                name: row?.name,
                type: row?.type,
                type_id: row?.type_id,
              };
              setCalendarList({ ...calendarList, list: listArr });
            }
          });
        }
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item md={9}>
          <Box display='flex' gap={2}>
            {eventTypeOptions?.length > 0
              ? eventTypeOptions?.map((item) => (
                  <Box sx={{ fontWeight: 'bold' }} display='flex' gap={1}>
                    {renderEventTypeIcon(item?.label)}
                    <Typography variant='button' sx={{ fontWeight: 'bold' }} py={1}>
                      {item?.label}
                    </Typography>
                  </Box>
                ))
              : ''}
          </Box>
        </Grid>
        <Grid item md={3}>
          <Box display='flex' justifyContent='end'>
            {selectedCalendarForm?.hasSelected ? (
              <Button
                variant='contained'
                color='primary'
                onClick={() => handleResetSelected()}
                sx={{ marginRight: '10px' }}
              >
                <RotateLeftIcon />
                Reset
              </Button>
            ) : (
              ''
            )}
            {auth.designation === 'admin' ? (
              <Button
                variant='contained'
                color='success'
                onClick={() => setAddEventModal({ ...addEventModal, toggle: true })}
              >
                <AddIcon />
                Add New Event
              </Button>
            ) : (
              ''
            )}
          </Box>
        </Grid>

        <Grid item md={6}>
          <AppointmentCalendar
            // initDate={moment().format('YYYY-MM-DD')}
            appointments={calendarData?.calendar}
            initDate={calendarData?.date}
            className='ec-container-centered'
            isDisableNavigation
            loading={calendarData?.loading}
            onClickDate={handleClickDate}
            selectedDate={selectedDate}
          />
        </Grid>
        <Grid item md={6} sx={{ height: '800px', overflowY: 'scroll' }}>
          {calendarList?.loading === false && calendarList?.list?.length > 0 ? (
            calendarList?.list?.map((item, i) => (
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1-content'
                  id='panel1-header'
                >
                  <Typography component='span' variant='h6' sx={{ fontWeight: 'bold' }}>
                    {moment(item.date).format('LL')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List dense={false}>
                    {item?.details?.length > 0
                      ? item?.details.map((detail, x) => (
                          <ListItem
                            secondaryAction={
                              <>
                                {auth.designation === 'admin' ? (
                                  <IconButton edge='end' aria-label='active'>
                                    <Stack
                                      direction='row'
                                      spacing={1}
                                      sx={{ alignItems: 'center' }}
                                    >
                                      <Typography>Plottable</Typography>
                                      <Switch
                                        checked={detail?.is_plottable === 1}
                                        size='small'
                                        onClick={(e) => handlePlottableEvent(e, detail, i, x)}
                                      />
                                    </Stack>
                                  </IconButton>
                                ) : (
                                  ''
                                )}
                                {auth.designation === 'admin' ? (
                                  <IconButton
                                    edge='end'
                                    aria-label='edit'
                                    onClick={() => handleViewEvent(detail?.id)}
                                  >
                                    <EditNoteIcon sx={{ color: 'blue' }} />
                                  </IconButton>
                                ) : (
                                  ''
                                )}
                                {auth.designation === 'admin' ? (
                                  <IconButton
                                    edge='end'
                                    aria-label='delete'
                                    onClick={() => handleDeleteEvent(detail?.id)}
                                  >
                                    <DeleteIcon sx={{ color: 'red' }} />
                                  </IconButton>
                                ) : (
                                  ''
                                )}
                              </>
                            }
                          >
                            <ListItemAvatar>{renderEventTypeIcon(detail?.type)}</ListItemAvatar>
                            <ListItemText>
                              <Typography>{detail?.name}</Typography>
                            </ListItemText>
                          </ListItem>
                        ))
                      : 'No Events'}
                  </List>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <Box display='flex' justifyContent='center' alignItems='center' minHeight='50vh'>
              {calendarList?.loading === false && calendarList?.list?.length < 1 ? (
                'NO EVENTS FOUND'
              ) : (
                <CircularProgress />
              )}
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
